// Behörighetskontroller som delas mellan sidor. Speglas i firestore.rules –
// ändras något här måste motsvarande funktion där ändras också.

// Roller som får redigera alla medarbetares konsultprofiler
export const PROFILE_MANAGER_ROLES = ['vd', 'superadmin', 'admin', 'ao_ansvarig', 'gruppledare'];

// Roller som räknas som admin (får dela ut behörigheten profilredaktör)
const ADMIN_ROLES = ['superadmin', 'vd', 'admin'];

export function isUserAdmin(userProfile) {
  return ADMIN_ROLES.includes(userProfile?.role) || userProfile?.isAdmin === true;
}

// Profilredaktör: anbudsansvariga har behörigheten via rollen,
// övriga kan få den av admin (users.canEditAllProfiles)
export function isProfileEditor(userProfile) {
  return userProfile?.isAnbudsansvarig === true || userProfile?.canEditAllProfiles === true;
}

export function canEditAllProfiles(userProfile) {
  return PROFILE_MANAGER_ROLES.includes(userProfile?.role)
    || isUserAdmin(userProfile)
    || isProfileEditor(userProfile);
}

export function canEditProfile(userProfile, currentUid, profileOwnerId) {
  if (!currentUid) return false;
  if (currentUid === profileOwnerId) return true;
  return canEditAllProfiles(userProfile);
}

// Flatbox (konfiguratorn och Flatbox-funktionerna i CRM): alla inloggade
// medarbetare utom externa konsulter (marknadskonsult). Flaggan users.isFlatbox
// har ingen funktion längre. Speglar canUseFlatbox() i firestore.rules, som
// dessutom kräver anställningsdomän och nekar inbjudna konsulter.
export function canUseFlatbox(userProfile) {
  return !!userProfile && userProfile.role !== 'marknadskonsult';
}
